<template>
	<div class="scrollable only-y">
		<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-bike widget-icon accent-text fs-30"></i> {{ $t('menu.volta') }}</h2>
			</div>
		</el-col>

		<el-card>
			<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
				<el-tab-pane label="Buy Transaction" name="buy">
					<template>
						<el-table v-loading="loadingQueueList"
							:data="buyList"
							style="width: 100%">
							<el-table-column
								fixed
								prop="created_at"
								label="Created At"
								width="160">
								<template slot-scope="scope">
									<span>
										{{ formatDate(scope.row.createdAt, "DD/MM/YY HH:mm:ss") }}
									</span>
								</template>
							</el-table-column>

							<el-table-column
								prop="name"
								label="Name"
								width="150">
							</el-table-column>

							<el-table-column
								prop="phone_number"
								label="Phone Number"
								width="150">
							</el-table-column>

							<el-table-column
								prop="company"
								label="Company"
								width="150">
							</el-table-column>

							<el-table-column
								prop="province"
								label="Province"
								width="150">
							</el-table-column>
							
							<el-table-column
								prop="city"
								label="City"
								width="150">
							</el-table-column>
							
							<el-table-column
								prop="address"
								label="Address"
								width="220">
							</el-table-column>

							<el-table-column
								prop="type"
								label="Type"
								width="150">
							</el-table-column>
							
							<el-table-column
								prop="unit"
								label="Unit"
								width="150">
							</el-table-column>
						</el-table>
					</template>
				</el-tab-pane>
				<el-tab-pane label="Rent Transaction" name="rent">
					<template>
						<el-table v-loading="loadingQueueList"
							:data="rentList"
							style="width: 100%">
							<el-table-column
								fixed
								prop="created_at"
								label="Created At"
								width="160">
								<template slot-scope="scope">
									<span>
										{{ formatDate(scope.row.createdAt, "DD/MM/YY HH:mm:ss") }}
									</span>
								</template>
							</el-table-column>

							<el-table-column
								prop="name"
								label="Name"
								width="150">
							</el-table-column>

							<el-table-column
								prop="phone_number"
								label="Phone Number"
								width="150">
							</el-table-column>

							<el-table-column
								prop="company"
								label="Company"
								width="150">
							</el-table-column>

							<el-table-column
								prop="province"
								label="Province"
								width="150">
							</el-table-column>
							
							<el-table-column
								prop="city"
								label="City"
								width="150">
							</el-table-column>
							
							<el-table-column
								prop="address"
								label="Address"
								width="220">
							</el-table-column>

							<el-table-column
								prop="rent_duration"
								label="Rental Duration"
								width="150">
							</el-table-column>
						</el-table>
					</template>
				</el-tab-pane>
			</el-tabs>
		</el-card>

		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import Template from './consumen/Template.vue'
const moment = require('moment')

export default {
  components: { Template },
	name: 'Volta',
	data () {
		return {
			loadingQueueList: false,
			queueList: [],
			buyList: [],
			rentList: [],
			btnPauseLoading: false,
			btnResumeLoading: false,
			activeTab: "buy",
		}
	},
	methods: {
		log(data) {
			console.log(data, " <<data");
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		tabClick(tab){
			if(tab.name == "buy"){
				this.getBuyList()
			} else if(tab.name == "rent"){
				this.getRentList()
			}
		},
		getBuyList(){
			this.loadingQueueList = true
			api({
				method: 'get',
				url: 'buy'
			}).then(response => {
				console.log("response buy list",response.data.data)
				this.buyList = response.data.data
				this.loadingQueueList = false
			}).catch(error => {
				console.log("error",error)
				this.loadingQueueList = false
			})
		},
		getRentList(){
			this.loadingQueueList = true
			api({
				method: 'get',
				url: 'rent'
			}).then(response => {
				console.log("response rental list",response.data.data)
				this.rentList = response.data.data
				this.loadingQueueList = false
			}).catch(error => {
				console.log("error",error)
				this.loadingQueueList = false
			})
		},
		getQueueList(){
			this.loadingQueueList = true
			api({
				method: 'post',
				url: 'whatsapp/queue/all'
			}).then(response => {
				console.log("response queue list",response.data.data.data)
				this.queueList = response.data.data.data
				this.loadingQueueList = false
			}).catch(error => {
				console.log("error",error)
				this.loadingQueueList = false
			})
		},
		stopQueue(key){
			console.log("key",key)
			api({
				method: 'post',
				url: 'whatsapp/queue/paused',
				data: {
					number: key.number.charAt(0) == 6 && key.number.charAt(1) == 2 ? '0' + key.number.substring(2) : key.number
				}
			}).then(response => {
				console.log("response queue paused",response.data.data)
				// this.$swal(this.$t('success'), 'Queue has been stop', "success")
				// this.getQueueList()
				// this.queueList = response.data.data.data
			}).catch(error => {
				console.log("error",error)
			})
		},
		resumeQueue(key) {
			var phoneNumber = 
				key &&
				key.number
					? key.number
					: '';
			this.btnResumeLoading = true;
			const number = phoneNumber.split('');
			if (number[0] === '6') {
				number.shift();
			}
			if (number[0] === '2') {
				number.shift();
				number.unshift('0');
			}
			let validNumber = number.join("");
			api({
				method: 'post',
				url: 'whatsapp/queue/resume',
				data: {
					number: validNumber
				}
			}).then(response => {
				let status =
					response &&
					response.data &&
					response.data.ec
						? response.data.ec
						: null;
				if(status === 200) {
					this.$swal(this.$t('success'), 'Queue has been resume', "success")
				}
				this.getQueueList()
				this.btnResumeLoading = false;
			}).catch(error => {
				console.error(error);
				this.btnResumeLoading = false;
			})
		},
		pauseQueue(key) {
			var phoneNumber = 
				key &&
				key.number
					? key.number
					: '';
			this.btnPauseLoading = true;
			const number = phoneNumber.split('');
			if (number[0] === '6') {
				number.shift();
			}
			if (number[0] === '2') {
				number.shift();
				number.unshift('0');
			}
			let validNumber = number.join("");
			api({
				method: 'post',
				url: 'whatsapp/queue/paused',
				data: {
					number: validNumber
				}
			}).then(response => {
				let status =
					response &&
					response.data &&
					response.data.ec
						? response.data.ec
						: null;
				if(status === 200) {
					this.$swal(this.$t('success'), 'Queue has been resume', "success")
				}
				this.getQueueList()
				this.btnPauseLoading = false;
			}).catch(error => {
				console.error(error);
				this.btnPauseLoading = false;
			})
		}
	},
	async mounted(){
		this.getBuyList()
		this.getRentList()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
